/* istanbul ignore file */
import DescriptionText from './DescriptionText';

export default DescriptionText;
